import { getToken } from 'lib/auth/token'
import { API_ROOT, AUTH_ROOT } from 'env'

async function apiFetch(path, parameters) {
  const authToken = getToken()
  const authHeader = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
  }
  return fetch(`${API_ROOT}/api/${path}`, { ...authHeader, ...parameters })
}

function authFetch(path, parameters) {
  return fetch(`${AUTH_ROOT}/${path}`, parameters)
}

function getOneloginLoginURL(returnToPath) {
  // URL encode the return to
  const returnTo = encodeURIComponent(
    `${window.location.origin}${returnToPath}`,
  )
  return `${AUTH_ROOT}/v2/login?return_to=${returnTo}`
}

function getConsumerLoginURL(returnToPath) {
  const returnTo = encodeURIComponent(
    `${window.location.origin}${returnToPath}`,
  )
  return `${AUTH_ROOT}/login?return_to=${returnTo}`
}

function getOneLoginSignupURL(returnToPath, params) {
  const returnTo = encodeURI(`${window.location.origin}${returnToPath}`)
  const signupParams = new URLSearchParams({
    return_to: returnTo,
    ...params,
  }).toString()
  return `${AUTH_ROOT}/v2/signup?${signupParams}`
}

export {
  API_ROOT,
  AUTH_ROOT,
  apiFetch,
  authFetch,
  getOneloginLoginURL,
  getConsumerLoginURL,
  getOneLoginSignupURL,
}
